import { color, Link, spacing } from '@gyym/ui'
import styled, { css } from 'styled-components'

interface HeaderContainerProps {
  isTop?: boolean
  isSticky?: boolean
}

export const HEADER_HEIGHT = 56 as const

export const HeaderContainer = styled.header<HeaderContainerProps>`
  position: ${({ isSticky, isTop }) =>
    isSticky ? 'fixed' : isTop ? 'absolute' : 'relative'};
  background: ${({ isSticky, isTop }) =>
    isTop && !isSticky ? 'transparent' : color('white')};
  left: 0;
  top: 0;
  height: ${HEADER_HEIGHT}px;
  width: 100%;
  z-index: 39;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${spacing(0, 4)};

  ${({ isTop, isSticky }) =>
    (!isTop || isSticky) &&
    css`
      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 20%);
    `}
`

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
`

export const IconButton = styled.button`
  background: none;
  height: 24px;
  width: 24px;
  display: flex;
  color: ${color('blue.01')};
  padding: 0;
  cursor: pointer;
  ${({ ml }: { ml?: number }) =>
    ml &&
    css`
      margin-left: ${spacing(ml)};
    `}
`
